import { DxpError } from '../../../core/error/dxp-error';

/**
 * Valore di dominio: le tre opzioni del menu allegati. Resta in inglese minuscolo perché forma anche il
 * modificatore BEM del componente — il testo mostrato vive in `public/i18n/{lingua}.json`
 * (`coding-style.md#testi-e-valori-di-dominio`).
 */
export type AttachmentOption = 'take-photo' | 'attach-photo' | 'attach-document';

export const ATTACHMENT_OPTIONS: readonly AttachmentOption[] = [
  'take-photo',
  'attach-photo',
  'attach-document',
] as const;

export interface ChatAttachment {
  readonly id: string;
  readonly fileName: string;
  readonly mimeType: string;
  readonly sizeBytes: number;
  readonly url: string;
  readonly kind: 'photo' | 'document';
}

export class AttachmentTooLargeError extends DxpError {
  readonly code = 'ATTACHMENT_TOO_LARGE';

  constructor(sizeBytes: number, maxSizeBytes: number) {
    super(`Attachment size ${sizeBytes} exceeds the configured maximum of ${maxSizeBytes}.`);
  }
}

export class AttachmentTypeNotAllowedError extends DxpError {
  readonly code = 'ATTACHMENT_TYPE_NOT_ALLOWED';

  constructor(mimeType: string) {
    super(`Attachment type '${mimeType}' is not allowed.`);
  }
}
